import React, { useEffect, useState } from 'react';
import { useData } from '../../../hooks/useData';
import { useToast } from '../../../hooks/useToast';
import { Tag } from '../../common/Tag';
import { usersDesignationServices } from '../../../APIServices/usersDesignationServices';
import Pagination from '../../../hooks/Pagination';
import UpdateDesignation from './UpdateDesignation';
import AddNewDesignation from './AddNewDesignation';
import DeleteDesignation from './DeleteDesignation';
import DeletedDesignatonHistory from './DeletedDesignatonHistory';

function DesignationManagement({ category }) {
  const toast = useToast();
  const [designationList, setDesignationList] = useState([]);
  const [designationCount, setDesignationCount] = useState(0);

  const [deleteDesignationList, setDeleteDesignationList] = useState([]);
  const [deleteDesignationCount, setDeleteDesignationCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState("");
  const [confirm, setConfirm] = useState(false);

  const [designation, setDesignation] = useState("");
  const [designationData, setDesignationData] = useState("");

  const [searchData, setSearchData] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(designationCount / itemsPerPage);

  const getUserDesignationData = async (e) => {
    setLoading(true);
    let data = await usersDesignationServices.getUserDesignationData(
      "active",
      category,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setDesignationList(data?.data || []);
    setDesignationCount(data?.count || 0);
    setLoading(false);
  };

  const [deletedPageNumber, setDeletedPageNumber] = useState(1);
  const [deletedItemsPerPage, setDeletedItemsPerPage] = useState(10);

  const getDeletedUserDesignationData = async (deletedPageNumber, deletedItemsPerPage) => {
    setLoading(true);
    let data = await usersDesignationServices.getUserDesignationData(
      "deleted",
      category,
      "",
      deletedPageNumber,
      deletedItemsPerPage
    );
    setDeleteDesignationList(data?.data || []);
    setDeleteDesignationCount(data?.count || 0);
    setLoading(false);
  };

  useEffect(() => {
    getUserDesignationData(pageNumber, itemsPerPage);
  }, [category, pageNumber, itemsPerPage]);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-eyebrow">
            Access control
          </div>

          <h1 className="page-title">
            Designation Management
          </h1>

          <p className="page-sub">
            Create, update, and manage designations used across the platform. Assign
            appropriate roles and permission levels to ensure secure and organized user
            access management.
          </p>
        </div>
      </div>

      <div className="flex between center mb-3">
        <div className="section-label">
          Designations{' '}
          <span className="count">
            {designationCount}
          </span>
        </div>

        <div className='hstack gap-4'>
          <button
            className="btn btn-primary"
            onClick={() => setModalOpen("add")}
          >
            <i className="ti ti-plus" />
            Add Designation
          </button>
          <button
            className="btn btn-danger"
            onClick={() => setModalOpen("deletedHistiory")}
          >
            <i className="ti ti-history" />
            Deleted History
          </button>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
            }}
          >
            <div className="buttonLoader" />

            <div
              style={{
                marginTop: 12,
              }}
            >
              Loading designations...
            </div>
          </div>
        ) : designationCount === 0 ? (
          <div
            style={{
              padding: 24,
              textAlign: 'center',
              color: 'var(--ink-3)',
            }}
          >
            <i
              className="ti ti-users"
              style={{
                fontSize: 24,
                display: 'block',
                marginBottom: 8,
              }}
            />

            No Designation. Click
            "Add Designation" to create one.
          </div>
        ) : (
          <>
            <table className="tbl">
              <thead>
                <tr>
                  <th>Designation</th>
                  <th>Users</th>
                  <th style={{ width: 120 }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {designationList.map((item) => (
                  <tr key={item.id}>
                    <td className="medium">
                      {item.designation}
                    </td>
                    <td>
                      <Tag variant="default">
                        {item.users}
                      </Tag>
                    </td>
                    <td>
                      <div className="flex gap-2">
                        <button
                          className="icon-btn"
                          title="Edit"
                          style={{
                            color:
                              'var(--info)',
                          }}
                          onClick={() => { setModalOpen("update"); setDesignationData(item); setDesignation(item?.designation) }}
                        >
                          <i className="ti ti-edit" />
                        </button>

                        <button
                          className="icon-btn"
                          title="Delete"
                          style={{
                            color:
                              'var(--danger)',
                          }}
                          onClick={() => { setModalOpen("delete"); setDesignationData(item); }}
                        >
                          <i className="ti ti-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
              <Pagination
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                totalPage={totalPage}
                totalItems={designationCount}
              />
          </>
        )}
      </div>

      {modalOpen === "add" && (
        <AddNewDesignation
          setModalOpen={setModalOpen}
          getUserDesignationData={getUserDesignationData}
          category={category}
        />
      )}
      {modalOpen === "update" && (
        <UpdateDesignation
          designationData={designationData}
          setModalOpen={setModalOpen}
          getUserDesignationData={getUserDesignationData}
          setConfirm={setConfirm}
          confirm={confirm}
        />
      )}
      {modalOpen === "delete" && (
        <DeleteDesignation
          getUserDesignationData={getUserDesignationData}
          getDeletedUserDesignationData={getDeletedUserDesignationData}
          setModalOpen={setModalOpen}
          designationData={designationData}
        />
      )}
      {modalOpen === "deletedHistiory" && (
        <DeletedDesignatonHistory
          getUserDesignationData={getUserDesignationData}
          getDeletedUserDesignationData={getDeletedUserDesignationData}
          setModalOpen={setModalOpen}
          deletedPageNumber={deletedPageNumber}
          setDeletedPageNumber={setDeletedPageNumber}
          deletedItemsPerPage={deletedItemsPerPage}
          setDeletedItemsPerPage={setDeletedItemsPerPage}
          setDeleteDesignationList={setDeleteDesignationList}
          deleteDesignationList={deleteDesignationList}
          setDeleteDesignationCount={setDeleteDesignationCount}
          deleteDesignationCount={deleteDesignationCount}
          category={category}
        />
      )}
    </div>
  );
}

export default DesignationManagement;